class ProfileModel {
  constructor() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.fullName = null;
    this.currency = {
      name: null,
      code: null,
    };
    this.country = {
      name: null,
    };
    this.enabled = null;
    this.dateOfBirth = null;
    this.joinedDate = null;
    this.verifiedAt = null;
    this.email = null;
    this.username = null;
    this.contacts = [];
    this.skype = null;
    this.files = [];
  }

  get status() {
    return this.verifiedAt ? 'Verified' : 'Not Verified';
  }

  get isVerified() {
    return this.verifiedAt ? true : false;
  }
}

export default ProfileModel;



// WEBPACK FOOTER //
// ./client/app/pages/profile/model/profile.model.js